<template>
  <div>
    <CallHelpTel />
  </div>
  <div class="flag_country">
    <template v-for="(flag, index) in flags" :key="index">
      <FlagFile :data="flag"></FlagFile>
    </template>
    <h3>{{ countryName }}</h3>
  </div>
  <div><hr class="hr flag_hr" /></div>
  <div class="timezone-grid">
    <div
      class="timezone-row"
      v-for="(group, index) in visibleRows"
      :key="index"
    >
      <TimeZoneCard
        v-for="tz in group"
        :key="tz"
        :timezone="tz"
        :city="tz"
        :country="countryName"
      />
    </div>
    <div
      style="text-align: center; margin-top: 12px"
      v-if="groupedTimezones.length > 1"
    >
      <a
        role="button"
        @click="toggleExpand"
        style="font-size: 1.125em; width: 100%"
      >
        <p :style="{ fontSize: fontSize.p + 'em' }">
          {{ expanded ? "收合時區列表" : "展開全部時區" }}
        </p>
      </a>

    </div>
  </div>

  <div><hr class="hr flag_hr" /></div>
  <div class="rwdCountry">
    <HotCountry />
    <div><hr class="hr" /></div>
  </div>
  <CountryOptions :menuList="outerLink" />
  <div><hr class="hr" /></div>
  <div class="sharing_title">
    <img src="../img/Employment_Sharing.svg" alt="" />
    <h3 :style="{ fontSize: fontSize.h3 + 'em' }">在地經驗分享</h3>
  </div>
  <div>
    <ul>
      <li class="video_wrap">
        <VideoCarousel :data="article.video" />
        <div class="video_group">
          <div
            class="video_item web_pic_item"
            v-for="(video, index) in article.video"
            :key="index"
          >
            <router-link
              :to="{
                name: 'VideoInner',
                params: { id: video.vid },
                query: { countryId },
              }"
              :title="video.title"
            >
              <div
                alt=""
                class="news_video videobox"
                v-html="video.originalFilePath"
              ></div>
              <p class="text_content" :style="{ fontSize: fontSize.p + 'em' }">
                {{ video.title }}
              </p>
            </router-link>
          </div>
          <div
            class="video_item"
            v-for="(video, index) in readyImgCounts"
            :key="index"
          >
            <div class="videobox">
              <img src="../../src/img/video_ready.png" alt="" />
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
  <div><hr class="hr" /></div>

  <template v-for="(item, i) in article.advice.items" :key="item.id">
    <template
      v-if="
        (article.advice.pagination.current - 1) *
          article.advice.pagination.pageSize <=
          i &&
        i <
          article.advice.pagination.current * article.advice.pagination.pageSize
      "
    >
      <GrayBlock :article="item" :countryId="countryId" justify="ArticlePage" />
    </template>
  </template>

  <a-pagination
    v-if="article.advice.items.length > article.advice.pagination.pageSize"
    v-model:current="article.advice.pagination.current"
    v-model:total="article.advice.items.length"
    v-model:pageSize="article.advice.pagination.pageSize"
    @change="changeAdvicePagination"
    :style="{ fontSize: fontSize.p + 'em' }"
  ></a-pagination>

  <div><hr class="hr" /></div>
  <HotCountryFix class="hcf" />
  <div>
    <div style="display: flex">
      <div class="pcBtn">
        <router-link :to="`/Publish_submit/${countryId}`" title="發表投稿">
          <img
            class="PulishC"
            src="../img/c_icon/PublishContribution.png"
            alt="在地經驗分享"
          />
          <img
            class="PulishC_hover"
            src="../img/c_icon/PublishContribution_hover.png"
            alt="在地經驗分享"
          />
          <p class="post">發表投稿</p>
        </router-link>
      </div>
      <div class="instructions">
        <DoubleLeftOutlined
          :style="{ fontSize: '1.4em' }"
        />投稿使用說明詳見此處唷!
      </div>
    </div>
    <div>
      <template v-if="isPc">
        <ContributionTable
          :contributionList="showContributionList"
          :countryId="countryId"
        />
      </template>
      <template v-else>
        <template v-for="article in showContributionList" :key="article.id">
          <ContributionRWD :data="article" />
        </template>
      </template>
    </div>
    <div class="article.contribution.pagination">
      <a-pagination
        v-if="
          article.contribution.items.length >
          article.contribution.pagination.pageSize
        "
        v-model:current="article.contribution.pagination.current"
        v-model:total="article.contribution.items.length"
        v-model:pageSize="article.contribution.pagination.pageSize"
        @change="changeSubmitPagination"
        :style="{ fontSize: fontSize.p + 'em' }"
      ></a-pagination>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  computed,
  inject,
  onMounted,
  watch,
  onBeforeUnmount,
} from "vue";
import { useRoute } from "vue-router";
import CallHelpTel from "../components/Home/CallHelpTel.vue";
import GrayBlock from "../components/ContentBlock.vue";
import CountryOptions from "../components/CountryOptions.vue";
import ContributionTable from "../components/ContributionTable.vue";
import HotCountryFix from "../components/HotCountryFix.vue";
import HotCountry from "../components/Home/HotCountry.vue";
import VideoCarousel from "../components/VideoCarousel.vue";
import FlagFile from "../components/FlagFile.vue";
import ContributionRWD from "../components/ContributionRWD.vue";
import { DoubleLeftOutlined } from "@ant-design/icons-vue";
import { apiCountries, apiCountry, apiMenu } from "@/api/api.js";
import { toArticleFormat } from "@/util/article";
import TimeZoneCard from "../components/TimeZoneCard.vue";
import countryCodeMap from "@/assets/data/country-code-map.json";
import mainTimezonesMap from "@/assets/data/main-timezones.json";
const timezones = computed(() => {
  const code = countryCodeMap[countryName.value];
  return mainTimezonesMap[code] || [];
});
const cardsPerRow = 3;
const groupedTimezones = computed(() => {
  const chunks = [];
  for (let i = 0; i < timezones.value.length; i += cardsPerRow) {
    chunks.push(timezones.value.slice(i, i + cardsPerRow));
  }
  return chunks;
});

const expanded = ref(false);
const visibleRows = computed(() =>
  expanded.value ? groupedTimezones.value : groupedTimezones.value.slice(0, 1)
);

const toggleExpand = () => {
  expanded.value = !expanded.value;
};
let fontSize = inject("fontSize");

const route = useRoute();
const countryId = computed(() =>
  route.params.countryId ? route.params.countryId : "61"
);
watch(
  () =>route.params.countryId,
  () => {
    expanded.value = false;
  },
  { immediate: true }
);

const isCountry = (str) => {
  console.log(str);
  const regex = /^\d{1,3}$/; // 正規表達式，表示字串開頭必須是 1~3 個數字，結尾不能再有其他字元
  return regex.test(str);
};

const showContributionList = computed(() => {
  const position = article.contribution.pagination.current;
  const result = article.contribution.items.filter(
    (list, i) =>
      i < position * article.contribution.pagination.pageSize &&
      i >= (position - 1) * article.contribution.pagination.pageSize
  );
  return result;
});


const flags = reactive([]); //國家國旗

const outerLink = reactive([]);
const fetchLinkUrl = async () => {
  const { data } = await apiMenu(countryId.value);
  outerLink.length = 0;
  outerLink.push(...data);
};

const article = reactive({
  video: [],
  advice: {
    items: [],
    pagination: {
      total: 0,
      current: 1,
      pageSize: 5,
    },
  },
  contribution: {
    items: [],
    pagination: {
      total: 0,
      current: 1,
      pageSize: 5,
    },
  },
});

const fetchArticle = async () => {
  const { data } = await apiCountries({
    countryId: countryId.value,
    expertAdvicePage: 1,
    contributorPage: 1,
  });

  // 抓國旗api
  flags.length = 0;
  flags.push(data);

  article.video = data.videos;
  article.advice.items = data.expertAdvices.map((d) => toArticleFormat(d));
  article.contribution.items = data.contributors;
};

const changeAdvicePagination = (currentPage) => {
  article.advice.pagination.current = currentPage;
};

const changeSubmitPagination = (clickPage) => {
  article.contribution.pagination.current = clickPage;
};

window.addEventListener("scroll", () => {
  let top =
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    window.pageYOffset;

  if (top >= 200) {
    const countryFix = document.querySelector(".hcf");
    countryFix.style.display = "block";
  } else {
    const countryFix = document.querySelector(".hcf");
    countryFix.style.display = "none";
  }
});

// 表格判斷
const isPc = ref(true);
onMounted(() => {
  handleResize();
  window.addEventListener("resize", handleResize);
  window.onresize = function () {
    const width = document.body.clientWidth;
    if (width <= 992) {
      const countryFix = document.querySelector(".hcf");
      countryFix.style.display = "none";
      isPc.value = false;
    } else {
      const countryFix = document.querySelector(".hcf");
      countryFix.style.display = "block";
      isPc.value = true;
    }
  };
});
onBeforeUnmount(() => {
  window.removeEventListener("resize", handleResize);
});

const cardsPerSlide = ref(2);
const handleResize = () => {
  const width = window.innerWidth;
  if (width < 576) {
    cardsPerSlide.value = 1;
  } else if (width < 992) {
    cardsPerSlide.value = 2;
  } else {
    cardsPerSlide.value = 3;
  }
};
const chunkArray = (arr, size) => {
  const chunked = [];
  for (let i = 0; i < arr.length; i += size) {
    chunked.push(arr.slice(i, i + size));
  }
  return chunked;
};
const chunkedTimezones = computed(() =>
  chunkArray(timezones.value, cardsPerSlide.value)
);
// 填補用圖片
const readyImgCounts = computed(() => {
  if (article.video.length === 0) return 4;
  else
    return article.video.length % 4 === 0 ? 0 : 4 - (article.video.length % 4);
});

// 國家名稱
const countryIdList = reactive([]);
const countryName = ref("日本");
async function getcountryName() {
  const res = await apiCountry().catch((err) => {
    console.log(err);
  });
  res.data.areas.forEach((area) => {
    area.countries.forEach((country) => {
      countryIdList.push(country);
    });
  });
  const thisPageCountry = countryIdList.filter(
    (country) => country.countryId == countryId.value
  );
  countryName.value = thisPageCountry[0].countryName;
}

const init = () => {
  if (!isCountry(countryId.value)) {
    location.href = "https://overseas.taiwanjobs.gov.tw/error/errorpage.html";
  }
  fetchLinkUrl();
  fetchArticle();
  getcountryName();
};

init();

watch(
  () => route.params.countryId,
  () => {
    init();
  }
);
</script>

<style lang="scss" scoped>
.flag_hr {
  margin: 15px 0 30px;
}
.instructions {
  display: flex;
  align-items: center;

  img {
    width: 30px;
    margin-left: 5px;
  }
}
.hcf {
  position: fixed;
  z-index: 99;
  top: 288px;
  left: 30px;
  display: none;
  @include lg {
    display: block;
  }
  @media screen and (max-width: 1199px) {
    display: none !important;
  }
}
.rwdCountry {
  display: none;
  @include xl {
    display: block;
  }
}
.sharing_title {
  img {
    width: 6%;
  }
}

.video_group {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  @include md {
    display: none;
  }
  .video_item {
    width: 24%;
    p {
      text-align: initial;
    }
    a {
      width: 100%;
    }
  }
  .videobox {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    :deep iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    :deep embed {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
.article.contribution.pagination {
  padding-top: 20px;
}

.pcBtn {
  border: $main_color 2px solid;
  border-radius: 5px;
  width: 120px;
  padding: 5px;
  cursor: pointer;
  margin-right: 20px;
  margin-bottom: 15px;
  .PulishC {
    display: inline-block;
  }
  .PulishC_hover {
    display: none;
  }
  a {
    @include flex_center;
  }
  &:hover {
    background-color: $main_color;
    .PulishC_hover {
      display: inline-block;
    }
    .PulishC {
      display: none;
    }
    .post {
      color: $main_sec_color;
    }
  }
}
.flag_country {
  display: flex;
  justify-content: center;
  align-items: center;
  h3 {
    margin-left: 8px;
  }
}
.timezone-grid {
  max-width: 1024px;
  margin: auto;
}
.timezone-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 16px;
  gap: 12px;
}
.timezone-row > * {
  flex: 1 1 calc(25% - 12px);
  max-width: calc(25% - 12px);
}
.ant-card-bordered {
  border: #e7e7e7 3px dashed;
}

.ant-card-bordered:hover {
  border: #024d73 3px dashed;
  background: #ffbf47;
}
</style>
